import { render, staticRenderFns } from "./costinventorysubject.vue?vue&type=template&id=36eabbb9&scoped=true&"
import script from "./costinventorysubject.vue?vue&type=script&lang=js&"
export * from "./costinventorysubject.vue?vue&type=script&lang=js&"
import style0 from "./costinventorysubject.vue?vue&type=style&index=0&id=36eabbb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eabbb9",
  null
  
)

export default component.exports